import {Component, OnInit, ViewEncapsulation} from '@angular/core';
import {MsalService} from "@azure/msal-angular";
import {Router} from "@angular/router";
import {AppConsts} from "../appConsts";

@Component({
  selector: 'app-navigation',
  templateUrl: './navigation.component.html',
  styleUrls: ['./navigation.component.css'],
  encapsulation: ViewEncapsulation.Emulated,
})
export class NavigationComponent implements OnInit {
  session:any;
  sidebar;
  constructor(public msalService: MsalService, private router: Router) { }

  ngOnInit() {
    this.session = this.msalService.instance.getAllAccounts()[0];
  }


  signout() {
    this.msalService.logout();
  }

  navigateToHome() {
    this.router.navigateByUrl(AppConsts.appBaseUrl);
  }
}
